module.exports = __webpack_public_path__ + "static/media/mugdha_bapat.f1f344f9.jpg";